import { Loader2 } from "lucide-react";
import { useLocation } from "react-router-dom";
// The stage of the start page (palette and background only). Imported here, in the app shell,
// because the start page's own chunk is what is still loading; import the file, never the
// `@/features/entry` barrel (that would pull the whole scene into the shell).
import "@/features/entry/entry-stage.css";

const LoadingLabel = () => <span className="sr-only">Seite wird geladen</span>;

/**
 * Suspense fallback of the lazy routes. The start page `/` is a fixed night stage (`light-only`
 * in the app theme, its own palette): there the fallback is that stage, empty, so a slow chunk
 * shows night blue instead of white with a blue spinner and then a hard cut. Every other route
 * keeps the light spinner.
 */
export const RouteFallback = () => {
  const { pathname } = useLocation();
  if (pathname === "/") {
    return (
      <div className="entry-scene" data-entry-scene="" role="status" aria-live="polite">
        <LoadingLabel />
      </div>
    );
  }
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-background text-foreground"
      role="status"
      aria-live="polite"
    >
      <Loader2 className="h-6 w-6 animate-spin text-primary" aria-hidden="true" />
      <LoadingLabel />
    </div>
  );
};
